module.exports = __webpack_public_path__ + "img/GB-WLS.6ed6805f.svg";